import { autoinject } from 'aurelia-framework';
import { GlobalAnalysisDto } from 'models/pen/GlobalAnalysis';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class GlobalAnalysisService extends BaseApiService<GlobalAnalysisDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, GlobalAnalysisDto);
  }
}
